import React from 'react';
const InteriorDecorators = () => <div className="service-page"><h1>Interior Decorators</h1><p>Transform your space with expert interior decorators.</p></div>;
export default InteriorDecorators;
